/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './declaration.defs.js'
export { main as default } from './declaration.defs.js'
